import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "explore_16",
  "use": "explore_16-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"explore_16\"><circle cx=\"8\" cy=\"8\" r=\".75\" /><path d=\"M8 4.3l1.25 2.22.15.25.25.14 2 1.09-2 1.1-.24.13-.15.25L8 11.7 6.74 9.48l-.14-.25-.25-.13L4.33 8l2-1.09.25-.14.14-.24L8 4.3m0-2L5.85 6 2.24 8l3.63 2L8 13.72 10.14 10l3.62-2-3.64-2z\" /><path d=\"M8 2a6 6 0 11-6 6 6 6 0 016-6m0-1a7 7 0 107 7 7 7 0 00-7-7z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol